import React, { useEffect, useState } from "react";
import {
  Table,
  Tabs,
  Row,
  Col,
  Image,
  Switch,
  Modal,
  message,
  Checkbox,
  Divider,
  notification,
  Popconfirm,
} from "antd";
import { CardContainer } from "../../components/Card/CardContainer";
import {
  UnorderedListOutlined,
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  CheckCircleFilled,
  VerticalAlignBottomOutlined,
} from "@ant-design/icons";
import { dateFormatter } from "../../utility/Formatter";
import { FlexCol, FlexRow } from "../../components/Container/Container";
import Text from "../../components/Text/Text";
import color from "../../resource/color";
import Button from "../../components/Button/Button";
import moment from "moment";
import Input from "../../components/Input/Input";
import { RangePicker } from "../../components/DatePicker/DatePicker";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  deletePromotion,
  excelMutiPromotion,
  getPromotion,
  updatePromotionStatus,
} from "../../datasource/PromotionDatasource";
import { PROMOTION_TYPE_NAME } from "../../definitions/promotion";
import image from "../../resource/image";
import Permission, { checkPermission } from "../../components/Permission/Permission";
import { useRecoilValue } from "recoil";
import { roleAtom } from "../../store/RoleAtom";
import icon from "../../resource/icon";
import dayjs from "dayjs";
import axios, { AxiosRequestConfig } from "axios";
import { BASE_URL } from "../../config/develop-config";
import { useNotificationContext } from "../../context/NotificationProvider";
import { formatFileSize } from "../../utility/formatFileSize";

type FixedType = "left" | "right" | boolean;
const REQUEST_DMY = "YYYY-MM-DD";

export const PromotionListPage: React.FC = () => {
  const pageSize = 10;
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { company, firstname, lastname } = userProfile;
  const roleData = useRecoilValue(roleAtom);
  const [searchParams, setSearchParams] = useSearchParams();

  const isCreate = checkPermission(["promotion", "create"], roleData);
  const isApprove = checkPermission(["promotion", "approve"], roleData);
  const isExcel = checkPermission(["promotion", "excel"], roleData);

  const navigate = useNavigate();
  const [keyword, setKeyword] = useState<string>(searchParams.get("keyword") || "");
  const [statusFilter, setStatusFilter] = useState<any>(
    searchParams.get("statusFilter") || undefined,
  );
  const [dateFilter, setDateFilter] = useState<any>();
  const [page, setPage] = useState<number>(parseInt(searchParams.get("page") || "1"));
  const [loading, setLoading] = useState(false);
  const [dataState, setDataState] = useState({
    count: 0,
    count_status: [],
    data: [] as any[],
  });
  const [modalMutiSelect, setModalMutiSelect] = useState<boolean>(false);
  const [proSelected, setProSelected] = useState<any[]>([]);
  const [deleteConfirmId, setDeleteConfirmId] = useState<string | null>(null);
  const [clearAllConfirmOpen, setClearAllConfirmOpen] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const { startUploadProcess } = useNotificationContext();
  const [progressValue, setProgressValue] = useState(0);

  useEffect(() => {
    if (!loading) fetchProduct();
  }, [keyword, statusFilter, page, dateFilter]);

  const setParams = (sD?: any, eD?: any) => {
    let sd = "",
      sm = "",
      sy = "",
      ed = "",
      em = "",
      ey = "";
    sd = sD && sD?.date();
    sm = sD && sD?.month() + 1;
    sy = sD && sD?.year();

    ed = eD && eD?.date();
    em = eD && eD?.month() + 1;
    ey = ed && eD?.year();

    setSearchParams({
      keyword,
      startDate: sd && sm && sy ? `${sy}-${sm}-${sd}` : "",
      endDate: ed && em && ey ? `${ey}-${em}-${ed}` : "",
      page: page.toString(),
      ...(statusFilter && { statusFilter }),
    });
  };

  const fetchProduct = async () => {
    try {
      setLoading(true);
      const sd = searchParams.get("startDate") || undefined;
      const ed = searchParams.get("endDate") || undefined;
      setParams(sd && dayjs(sd), ed && dayjs(ed));
      if (sd || ed) {
        setDateFilter([dayjs(sd), dayjs(ed)]);
      }
      const { data, count, count_status } = await getPromotion({
        company,
        promotionStatus: statusFilter ? statusFilter : undefined,
        startDate: (sd && dayjs(sd).format(REQUEST_DMY)) || undefined,
        endDate: (ed && dayjs(ed).format(REQUEST_DMY)) || undefined,
        searchText: keyword,
        take: pageSize,
        page,
      });

      const mapData = data.map((d: any) => {
        const isChecked = proSelected.find((p) => p.promotionId === d.promotionId);
        return {
          ...d,
          isChecked: isChecked,
        };
      });
      setDataState({
        data: mapData,
        count,
        count_status,
      });
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const PageTitle = () => {
    return (
      <Row align='middle' gutter={16} justify={"start"}>
        <Col className='gutter-row' span={isCreate && isExcel ? 8 : isCreate || isExcel ? 11 : 14}>
          <div>
            <span
              className='card-label font-weight-bolder text-dark'
              style={{ fontSize: 20, fontWeight: "bold" }}
            >
              รายการโปรโมชัน
            </span>
          </div>
        </Col>
        <Col className='gutter-row' xl={4} sm={6}>
          <div style={{ width: "100%" }}>
            <Input
              placeholder='ค้นหาโปรโมชัน'
              prefix={<SearchOutlined style={{ color: "grey" }} />}
              defaultValue={keyword || searchParams.get("keyword") || ""}
              onPressEnter={(e) => {
                const value = (e.target as HTMLTextAreaElement).value;
                setKeyword(value);
                setPage(1);
                setParams(dayjs(searchParams.get("startDate")), dayjs(searchParams.get("endDate")));
              }}
              onChange={(e) => {
                const value = (e.target as HTMLTextAreaElement).value;
                if (!value) {
                  setKeyword("");
                  setPage(1);
                  setParams(
                    dayjs(searchParams.get("startDate")),
                    dayjs(searchParams.get("endDate")),
                  );
                }
              }}
            />
          </div>
        </Col>
        <Col className='gutter-row' xl={6} sm={6}>
          <RangePicker
            allowEmpty={[true, true]}
            enablePast
            value={dateFilter}
            onChange={(dates, dateString) => {
              setPage(1);
              setDateFilter(dates);
              setParams(dates && dates[0], dates && dates[1]);
            }}
          />
        </Col>
        {isCreate && (
          <Col className='gutter-row' xl={3} sm={6}>
            <Button
              type='primary'
              title='+ สร้างโปรโมชัน'
              height={40}
              onClick={() => (window.location.pathname = "/PromotionPage/promotion/create")}
            />
          </Col>
        )}
        {isExcel && (
          <Col className='gutter-row' xl={3} sm={6}>
            <Button
              type='primary'
              typeButton={proSelected.length > 0 ? "primary" : "disabled"}
              title={
                <>
                  <VerticalAlignBottomOutlined style={{ fontSize: "18px" }} /> Export (
                  {proSelected.length}/10)
                </>
              }
              height={40}
              onClick={() => proSelected.length && setModalMutiSelect(true)}
            />
          </Col>
        )}
      </Row>
    );
  };

  const tabsItems = [
    {
      label: `ทั้งหมด (${
        dataState?.count_status?.reduce((acc: number, cur: any) => acc + parseInt(cur.count), 0) ||
        0
      })`,
      key: "ALL",
    },
    {
      label: `Active (${
        (dataState?.count_status?.find((c: any) => c.promotion_status) as any)?.count || 0
      })`,
      key: "true",
    },
    {
      label: `Inactive (${
        (dataState?.count_status?.find((c: any) => !c.promotion_status) as any)?.count || 0
      })`,
      key: "false",
    },
  ];

  const ActionBtn = ({ onClick, icon }: any) => {
    return (
      <Col span={6}>
        <div className='btn btn-icon btn-light btn-hover-primary btn-sm' onClick={onClick}>
          <span
            className='svg-icon svg-icon-primary svg-icon-2x'
            style={{ color: color["primary"] }}
          >
            {icon}
          </span>
        </div>
      </Col>
    );
  };

  const selectedAll = (e: boolean) => {
    const newData = dataState.data.map((d) => ({ ...d, isChecked: e }));
    setDataState({ ...dataState, data: newData });
    setProSelected((prev) => {
      const currentPageIds = new Set(newData.map((d) => d.promotionId));

      if (!e) {
        return prev.filter((item) => !currentPageIds.has(item.promotionId));
      }

      const nextSelected = [
        ...prev.filter((item) => !currentPageIds.has(item.promotionId)),
        ...newData,
      ];
      return Array.from(new Map(nextSelected.map((item) => [item.promotionId, item])).values());
    });
  };

  const selectedOne = (e: boolean, promotionId: string) => {
    const newData = dataState.data.map((item) =>
      item.promotionId === promotionId ? { ...item, isChecked: e } : item,
    );
    setDataState({ ...dataState, data: newData });
    setProSelected((prev) => {
      if (!e) {
        return prev.filter((item) => item.promotionId !== promotionId);
      }

      const selectedItem = newData.find((item) => item.promotionId === promotionId);
      if (!selectedItem) {
        return prev;
      }

      return Array.from(
        new Map([...prev, selectedItem].map((item) => [item.promotionId, item])).values(),
      );
    });
  };

  const resetSelected = () => {
    const mapData = dataState.data.map((d: any) => {
      return {
        ...d,
        isChecked: false,
      };
    });
    setDataState({
      data: mapData,
      count: dataState.count,
      count_status: dataState.count_status,
    });
    setProSelected([]);
  };

  const openNotification = async () => {
    setIsExporting(true);
    setModalMutiSelect(false);
    const proIdList = proSelected.map((p) => p.promotionId);
    const params = { id: proIdList, company };

    try {
      const config = await excelMutiPromotion(params);
      if (config) {
        const blob = new Blob([config], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        startUploadProcess(
          "",
          progressValue,
          setProgressValue,
          {
            placement: "bottomRight",
            duration: 2,
            label: "กำลังเตรียมไฟล์ของคุณ รอสักครู่!",
            progressInterval: 900,
          },
          async () => {
            try {
              const a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = `รายงานโปรโมชัน_${new Date()
                .toLocaleDateString("us-EN", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                })
                .replace(/\//g, "-")}.xlsx`;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(a.href);
              formatFileSize(blob.size);
            } catch (error) {
              message.error("Export โปรโมชันไม่สำเร็จ");
            } finally {
              setIsExporting(false);
            }
          },
        );
      }
    } catch (error) {
      console.error("Error submitting report:", error);
    } finally {
      setModalMutiSelect(false);
      resetSelected();
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      hidden: !isExcel,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol align='center'>
              <Checkbox
                checked={row.isChecked}
                onChange={(e) => selectedOne(e.target.checked, row.promotionId)}
                disabled={proSelected.length === 10 && !row.isChecked}
              />
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ชื่อโปรโมชัน",
      dataIndex: "promotionName",
      key: "promotionName",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexRow align='center'>
              <div style={{ marginRight: 16 }}>
                <Image
                  src={row.promotionImageSecond || image.emptyPromotion}
                  width={80}
                  style={{ borderRadius: "10px" }}
                />
              </div>
              <FlexCol>
                <Text level={5}>{value}</Text>
                <Text level={6} color='Text3'>
                  {row.promotionCode}
                </Text>
              </FlexCol>
            </FlexRow>
          ),
        };
      },
    },
    {
      title: "ประเภทโปรโมชัน",
      dataIndex: "promotionType",
      key: "promotionType",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text level={5}>{PROMOTION_TYPE_NAME[value]}</Text>
              <Text level={6} color='Text3'>
                {row.numOfStore}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ระยะเวลา",
      dataIndex: "startDate",
      key: "startDate",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text level={5}>
                {dateFormatter(row.startDate)} - {dateFormatter(row.endDate)}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "โควต้ารวม",
      dataIndex: "isQuotaAll",
      key: "isQuotaAll",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Row justify={"center"}>
              <FlexCol>
                {value ? (
                  <CheckCircleFilled style={{ color: color.success, fontSize: "20px" }} />
                ) : (
                  <CheckCircleOutlined style={{ color: color.Disable, fontSize: "20px" }} />
                )}
              </FlexCol>
            </Row>
          ),
        };
      },
    },
    {
      title: "โควต้ารายร้าน",
      dataIndex: "isQuotaShop",
      key: "isQuotaShop",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Row justify={"center"}>
              <FlexCol>
                {value ? (
                  <CheckCircleFilled style={{ color: color.success, fontSize: "20px" }} />
                ) : (
                  <CheckCircleOutlined style={{ color: color.Disable, fontSize: "20px" }} />
                )}
              </FlexCol>
            </Row>
          ),
        };
      },
    },
    {
      title: "อัปเดตโดย",
      dataIndex: "updateBy",
      key: "updateBy",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text level={5}>{value || "-"}</Text>
              <Text level={6} color='Text3'>
                {dateFormatter(row.updatedAt)}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "สถานะ",
      dataIndex: "promotionStatus",
      key: "promotionStatus",
      hidden: !isApprove,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <>
              {!moment(row.endDate).isBefore(moment()) ? (
                <Switch
                  checked={value}
                  onChange={async (checked: boolean) => {
                    await updatePromotionStatus({
                      promotionId: row.promotionId,
                      isDraft: row.isDraft,
                      promotionStatus: checked,
                      updateBy: firstname + " " + lastname,
                    })
                      .then((res) => {
                        fetchProduct();
                        message.success("แก้ไขสถานะโปรโมชั่นสำเร็จ");
                      })
                      .catch(() => message.error("แก้ไขสถานะโปรโมชั่นไม่สำเร็จ"));
                  }}
                  disabled={
                    !isApprove || moment(row.endDate).isBefore(moment()) || row.promotionStatus
                  }
                />
              ) : (
                <Text level={6} color='Text3'>
                  หมดอายุ
                </Text>
              )}
            </>
          ),
        };
      },
    },
    {
      title: "สถานะ",
      dataIndex: "promotionStatus",
      key: "promotionStatus",
      hidden: isApprove,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <>
              {!moment(row.endDate).isBefore(moment()) ? (
                <Text level={6} color={value ? "success" : "error"}>
                  {value ? "เปิดการใช้งาน" : "ปิดการใช้งาน"}
                </Text>
              ) : (
                <Text level={6} color='Text3'>
                  หมดอายุ
                </Text>
              )}
            </>
          ),
        };
      },
    },
    {
      title: "จัดการ",
      dataIndex: "action",
      key: "action",
      fixed: "right" as FixedType | undefined,
      width: "15%",
      hidden:
        !checkPermission(["promotion", "create"], roleData) &&
        !checkPermission(["promotion", "view"], roleData) &&
        !checkPermission(["promotion", "edit"], roleData) &&
        !checkPermission(["promotion", "delete"], roleData),
      render: (value: any, row: any, index: number) => {
        const isExpired = moment(row.endDate).isBefore(moment());
        return {
          children: (
            <>
              <Row>
                <Permission permission={["promotion", "view"]}>
                  <ActionBtn
                    onClick={() => navigate("/PromotionPage/promotion/detail/" + row.promotionId)}
                    icon={<UnorderedListOutlined />}
                  />
                </Permission>
                {!isExpired && (
                  <Permission permission={["promotion", "edit"]}>
                    <ActionBtn
                      onClick={() => navigate("/PromotionPage/promotion/edit/" + row.promotionId)}
                      icon={<EditOutlined />}
                    />
                  </Permission>
                )}
                <Permission permission={["promotion", "create"]}>
                  <ActionBtn
                    onClick={() => {
                      const query = new URLSearchParams({ copy_id: row.promotionId }).toString();
                      Modal.confirm({
                        title: "ต้องการคัดลอกโปรโมชันนี้ใช่หรือไม่",
                        content: `โปรดตรวจสอบรายละเอียดโปรโมชัน “${row.promotionName}” (${row.promotionCode}) ที่ต้องการคัดลอก ก่อนกดยืนยัน`,
                        okText: "ยืนยัน",
                        onOk: () => navigate("/PromotionPage/promotion/create/?" + query),
                      });
                    }}
                    icon={<img src={icon.dupplicate} style={{ width: 16, height: 16 }} />}
                  />
                </Permission>
                {!isExpired && (
                  <Permission permission={["promotion", "delete"]}>
                    <ActionBtn
                      onClick={() =>
                        Modal.confirm({
                          title: "ยืนยันการลบโปรโมชั่น",
                          okText: "",
                          cancelText: "",
                          onOk: async () => {
                            await deletePromotion({
                              promotionId: row.promotionId,
                              updateBy: firstname + " " + lastname,
                            })
                              .then((res) => {
                                navigate(0);
                              })
                              .catch(() => message.error("ลบโปรโมชั่นไม่สำเร็จ"));
                          },
                        })
                      }
                      icon={<DeleteOutlined style={{ color: color.error }} />}
                    />
                  </Permission>
                )}
              </Row>
            </>
          ),
        };
      },
    },
  ].filter((item) => !item.hidden);

  return (
    <>
      <CardContainer>
        <PageTitle />
        <br />
        <Tabs
          items={tabsItems}
          defaultActiveKey={statusFilter || searchParams.get("statusFilter")}
          onChange={(key: string) => {
            setStatusFilter(key === "ALL" ? undefined : key);
            setPage(1);
            setParams(dayjs(searchParams.get("startDate")), dayjs(searchParams.get("endDate")));
          }}
        />
        <Table
          className='rounded-lg'
          columns={columns}
          scroll={{ x: "max-content" }}
          dataSource={dataState?.data?.map((d: object, i) => ({ ...d, key: i }))}
          pagination={{
            position: ["bottomCenter"],
            pageSize,
            current: page || parseInt(searchParams.get("page") || "1"),
            total: dataState?.count,
            onChange: (p) => {
              setPage(p);
              setParams(dayjs(searchParams.get("startDate")), dayjs(searchParams.get("endDate")));
            },
            showSizeChanger: false,
          }}
          loading={loading}
          size='large'
          tableLayout='fixed'
        />
      </CardContainer>
      {isExporting && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(128, 128, 128, 0.18)",
            cursor: "not-allowed",
            zIndex: 999,
          }}
        />
      )}
      {modalMutiSelect && (
        <Modal
          open={modalMutiSelect}
          footer={false}
          width={1000}
          onCancel={() => setModalMutiSelect(false)}
          centered
        >
          <Text level={4} fontWeight={600}>
            รายการโปรโมชันที่ต้องการ Export จำนวน {proSelected.length} รายการ
          </Text>
          <Divider style={{ margin: "12px 0px 0px 12px", paddingBottom: "15px" }} />
          <Row justify='end' gutter={8} style={{ paddingBottom: "10px" }}>
            <Col>
              <Popconfirm
                placement='top'
                open={clearAllConfirmOpen}
                onOpenChange={setClearAllConfirmOpen}
                title={
                  <Row justify={"space-between"} gutter={8}>
                    <Col>
                      <Button
                        size='small'
                        title={
                          <Text level={6} color='primary'>
                            ยกเลิก
                          </Text>
                        }
                        typeButton='primary-light'
                        height={25}
                        style={{ padding: "0 12px" }}
                        onClick={() => setClearAllConfirmOpen(false)}
                      />
                    </Col>
                    <Col>
                      <Button
                        size='small'
                        title={
                          <Text level={6} color='white'>
                            ลบ
                          </Text>
                        }
                        typeButton='danger'
                        height={25}
                        style={{ padding: "0 12px" }}
                        onClick={() => {
                          setClearAllConfirmOpen(false);
                          setModalMutiSelect(false);
                          resetSelected();
                          setProSelected([]);
                        }}
                      />
                    </Col>
                  </Row>
                }
                icon={false}
                showCancel={false}
                okButtonProps={{ style: { display: "none" } }}
              >
                <Text level={6} color='primary' style={{ cursor: "pointer" }}>
                  ล้างทั้งหมด
                </Text>
              </Popconfirm>
            </Col>
          </Row>
          <Row
            justify='start'
            gutter={8}
            style={{
              padding: "8px",
              backgroundColor: color.Disable,
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
            }}
          >
            <Col span={11}>
              <Text fontWeight={600}> ชื่อโปรโมชัน</Text>
            </Col>
            <Col span={8}>
              <Text fontWeight={600}>ประเภท</Text>
            </Col>
            <Col span={3}>
              <Text fontWeight={600}>สถานะ</Text>
            </Col>
            <Col>
              <Text fontWeight={600}>จัดการ</Text>
            </Col>
          </Row>
          <div style={{ maxHeight: 400, overflowY: "auto", paddingRight: 8, paddingTop: 8 }}>
            {proSelected.map((d: any, i: number) => (
              <Row key={i} justify='start' gutter={16} style={{ padding: "8px" }}>
                <Col span={3}>
                  <Image
                    src={d.promotionImageSecond || image.emptyPromotion}
                    width={60}
                    style={{ borderRadius: "10px", marginRight: 16 }}
                    preview={false}
                  />
                </Col>
                <Col span={8}>
                  <FlexCol>
                    <Text level={5}>{d.promotionName}</Text>
                    <Text level={6} color='Text3'>
                      {d.promotionCode}
                    </Text>
                  </FlexCol>
                </Col>
                <Col span={8}>
                  <Text level={5}>{PROMOTION_TYPE_NAME[d.promotionType]}</Text>
                </Col>
                <Col span={3}>
                  <Text
                    level={6}
                    color={
                      d.promotionStatus
                        ? "success"
                        : !moment(d.endDate).isBefore(moment())
                          ? "error"
                          : "Text3"
                    }
                  >
                    {d.promotionStatus
                      ? "เปิดการใช้งาน"
                      : !moment(d.endDate).isBefore(moment())
                        ? "ปิดการใช้งาน"
                        : "หมดอายุ"}
                  </Text>
                </Col>
                <Col>
                  <Popconfirm
                    placement='top'
                    open={deleteConfirmId === d.promotionId}
                    onOpenChange={(open) => setDeleteConfirmId(open ? d.promotionId : null)}
                    title={
                      <Row justify={"space-between"} gutter={8}>
                        <Col>
                          <Button
                            size='small'
                            title={
                              <Text level={6} color='primary'>
                                ยกเลิก
                              </Text>
                            }
                            typeButton='primary-light'
                            height={25}
                            style={{ padding: "0 12px" }}
                            onClick={() => setDeleteConfirmId(null)}
                          />
                        </Col>
                        <Col>
                          <Button
                            size='small'
                            title={
                              <Text level={6} color='white'>
                                ลบ
                              </Text>
                            }
                            typeButton='danger'
                            height={25}
                            style={{ padding: "0 12px" }}
                            onClick={() => {
                              selectedOne(false, d.promotionId);
                              setDeleteConfirmId(null);
                              if (proSelected.length === 1) {
                                setModalMutiSelect(false);
                              }
                            }}
                          />
                        </Col>
                      </Row>
                    }
                    icon={false}
                    showCancel={false}
                    okButtonProps={{ style: { display: "none" } }}
                  >
                    <ActionBtn
                      icon={
                        <DeleteOutlined
                          style={{ color: color.error }}
                          //onClick={() => selectedOne(false, d.promotionId)}
                        />
                      }
                    />
                  </Popconfirm>
                </Col>
              </Row>
            ))}
          </div>
          <Divider />
          <Row gutter={16} justify={"end"}>
            <Col span={4}>
              <Button
                size='small'
                title='ยกเลิก'
                typeButton='primary-light'
                style={{
                  width: "100%",
                  height: "32px",
                  lineHeight: "32px",
                  padding: "0 16px",
                }}
                onClick={() => setModalMutiSelect(false)}
              />
            </Col>
            <Col span={4}>
              <Button
                size='small'
                title='Export'
                typeButton={"primary"}
                style={{
                  width: "100%",
                  height: "32px",
                  lineHeight: "32px",
                  padding: "0 16px",
                }}
                onClick={() => {
                  openNotification();
                }}
              />
            </Col>
          </Row>
        </Modal>
      )}
    </>
  );
};
